import store from "src/datahandling/redux/store";
import { SignalRManager } from "./core/SignalRManager";
import { TokenRefresher } from "./core/tokenRefresher";
import type { SignalRInitOptions } from "./types";
export { signalRLiveReducer, signalRLiveSlice as signalRSlice } from "./store/slice";
export { useSignalRLiveData } from "./hooks/useSignalRLiveData";
export { useSignalRValue } from "./hooks/useSignalRValue";
export { useSignalRStatus } from "./hooks/useSignalRStatus";
export { useSignalRSiteSubscription } from "./hooks/useSignalRCompanySubscription";

export type { SensorValue, UnitSensorMap, SensorDataMap, ConnectionStatus, SignalRError, SignalRInitOptions } from "./types";
export type { UseSignalRValueParams } from "./hooks/useSignalRValue";
export type { SignalRStatus } from "./hooks/useSignalRStatus";

let tokenRefresher: TokenRefresher | null = null;

export function initializeSignalR(options: SignalRInitOptions): () => void {
	const { signalRUrl, getAccessToken } = options;

	if (!signalRUrl) {
		console.error("[SignalR] Cannot initialize: signalRUrl is required");
		return () => {};
	}

	const manager = SignalRManager.getInstance();
	manager.initialize(store.dispatch);

	getAccessToken()
		.then((token) => {
			if (!token) {
				console.error("[SignalR] Cannot connect: no access token");
				return;
			}
			return manager.connect(signalRUrl, token);
		})
		.catch((error) => {
			console.error("[SignalR] Failed to initialize:", error);
		});

	tokenRefresher = new TokenRefresher();
	tokenRefresher.start(manager, getAccessToken);

	return () => {
		tokenRefresher?.stop();
		tokenRefresher = null;
		manager.terminate();
	};
}
